import React, { useEffect, useState, useRef } from 'react';
import '../style/PopupCoupon.css';

const coupons = [
  "TRAVEL500",
  "SAVE20NOW",
  "FOODIE15",
  "MOVIE100",
  "SHOP10",
  "ELECTRO50",
  "FESTIVE75",
  "NEWUSER30",
  "GROCERY25",
  "WELCOME5"
];

// Randomly pick one coupon per session
const getCouponForUser = () => {
  return coupons[Math.floor(Math.random() * coupons.length)];
};

const PopupCoupon = () => {
  const [showPopup, setShowPopup] = useState(true);
    const [copied, setCopied] = useState(false);
  const [couponCode] = useState(getCouponForUser());
  const [revealed, setRevealed] = useState(false);
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    // Fill canvas with gray color (scratch surface)
    ctx.fillStyle = '#c0c0c0';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const scratch = (e) => {
      const rect = canvas.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 20, 0, Math.PI * 2, false);
      ctx.fill();
    };

    const checkReveal = () => {
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let transparentPixels = 0;
      for (let i = 0; i < imageData.data.length; i += 4) {
        if (imageData.data[i + 3] === 0) transparentPixels++;
      }
      const percent = (transparentPixels / (canvas.width * canvas.height)) * 100;
      if (percent > 60 && !revealed) {
        setRevealed(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 5000); // Auto-close in 5 seconds
      }
    };

    const handleScratch = (e) => {
      scratch(e);
      checkReveal();
    };

    canvas.addEventListener('mousedown', () => {
      canvas.addEventListener('mousemove', handleScratch);
    });
    canvas.addEventListener('mouseup', () => {
      canvas.removeEventListener('mousemove', handleScratch);
    });
    canvas.addEventListener('touchstart', handleScratch);
    canvas.addEventListener('touchmove', handleScratch);

    return () => {
      canvas.removeEventListener('touchstart', handleScratch);
      canvas.removeEventListener('touchmove', handleScratch);
      canvas.removeEventListener('mousemove', handleScratch);
    };
  }, [revealed]);

  const handleCopy = () => {
    navigator.clipboard.writeText(couponCode);
      setCopied(true); // ✅ show "Copied!"
    setTimeout(() => setCopied(false), 2000);
  };

  if (!showPopup) return null;

  return (
    <div className="popup-overlay" ref={containerRef}>
      <div className="popup-coupon">
        <span className="close-btn" onClick={() => setShowPopup(false)}>&times;</span>
        <div className="coupon-text">
           {revealed ? (
            <>
              <p className="coupon-code">{couponCode}</p>
              <button 
                className={`copy-btn ${copied ? 'copied' : ''}`} 
                onClick={handleCopy}
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </>
          ) : (
            <p className="scratch-hint">Scratch to reveal your coupon!</p>
          )}
        </div>
        {!revealed && (
          <canvas ref={canvasRef} className="scratch-canvas"></canvas>
        )}
      </div>
    </div>
  );
};

export default PopupCoupon;
